export const ORGANIZATION_EDITOR_FIELD_NAMES = {
    name: 'publicName',
    type: 'organizationTypes',
    category: 'hierarchicalCategories',
    roles: 'organizationRole',
    contact: 'contact',
    locations: 'locations'
};

export const ORGANIZATION_SEARCH_QUERY_FRAGMENT = 'OrganizationProductServiceNoteReference';

export const ORGANIZATION_TYPES = {
    campus: 'Campus'
};
